
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import {FormLabel} from '@material-ui/core'
const styles = theme => ({
    label: {
        color: '#263238',
        display: 'block',
        fontWeight: '500',
        fontSize: '1.2rem',
        fontWeight: '500',
        lineHeight: '20px',
        letterSpacing: '-0.05px',
        marginBottom: '0',
        cursor: 'pointer',
    }
});
class SessionLabel extends React.Component { 
    render() { 
        let {label = '',required = false, classes} = this.props 
        return (
            <FormLabel 
                required = {required} 
                className={classes.label}>
                    {label}
            </FormLabel> 
        );
    }
}
  
export default (withStyles(styles)(SessionLabel))